import React from 'react';
export var defaultLayoutContext = 'fullWidth';
export var LayoutContext = /*#__PURE__*/React.createContext(defaultLayoutContext);